<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="时间选择：" class="width100">
              <el-radio-group
                v-model="tableFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(tableFrom.date)"
              >
                <el-radio-button
                  v-for="(item,i) in fromList.fromTxt"
                  :key="i"
                  :label="item.val"
                >{{ item.text }}</el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px;"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item label="关键字：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入分类名称/sku"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <cards-data :card-lists="cardLists" />
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
        row-key="recovery_category_id"
        lazy
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column
          label="分类名称"
          min-width="200"
          expand-row-keys="recovery_category_id"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.cate_name?scope.row.cate_name:'其他'}}</span>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="spec_type"-->
        <!--          label="规格"-->
        <!--          min-width="100"-->
        <!--        >-->
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ scope.row.spec_type == 1 ? '多规格' :'单规格' }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column
          label="在库数量"
          prop="recovery_num"
          min-width="100" />
        <el-table-column
          label="已出库数量"
          prop="outbound_num"
          min-width="100" />
        <el-table-column
          label="已出库平均单价"
          prop="outbound_price"
          min-width="100" />
        <el-table-column
          label="已出库总金额"
          prop="outbound_amount"
          min-width="100" />
        <el-table-column
          label="批号"
          prop=""
          min-width="100">
          <template slot-scope="scope">
            <p v-for="(item,index) in scope.row.stock_batch">
              {{item.batch_number}} <span style="font-size: 16px;color: red;margin-left: 10px">x{{item.batch_num}}</span>
            </p>
          </template>

        </el-table-column>
        <el-table-column label="操作" min-width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" v-if = 'scope.row.level == 3' size="small"  @click="setRecoveryStock(scope.row)">设置库存</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>


<!--    修改库存-->
    <el-dialog
      title="修改库存"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="修改库存" prop="pass">
          <el-radio v-model="ruleForm.type" :label="1">增加</el-radio>
          <el-radio v-model="ruleForm.type" :label="0">减少</el-radio>
        </el-form-item>
        <el-form-item label="库存" prop="checkPass">
          <el-input-number v-model="ruleForm.stock"  :min="1" label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item label="出库价格" prop="checkPass" v-if="ruleForm.type==0">
          <el-input v-model="ruleForm.outbound_price" placeholder="请输入内容" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="" prop="checkPass">
          <el-button type="primary" @click="addBatchFn">增加批号</el-button>
        </el-form-item>
        <el-form-item label="录入批号" prop="checkPass" v-for="(item,index) in ruleForm.batch_list">
          <el-input v-model="item.batch_number" placeholder="请输入内容" style="width: 300px;"></el-input>
          <el-input-number v-model="item.batch_num" @change="batchChange($event,index)" :max="maxFn(item,index)" label="描述文字" style="margin-left: 20px"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="batchConfirm">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {
  recoveryCategoryDeleteApi,
  recoveryCategoryListApi,
  recoveryCategoryStatusApi,
  recoveryStockCardListApi,
  RecoveryStockLadderListApi,
  setRecoveryStockFormApi,
  stockSetUpdate
} from "@/api/recovery";
import {roterPre} from "@/settings";
import cardsData from "@/components/cards";
import {fromList} from "@/libs/constants";
export default {
  name: 'recoveryCategory',
  components: {cardsData},
  computed:{
    maxFn(){
      return function (item,index) {
        let num = 0
          this.ruleForm.batch_list.map((item1,index1)=>{
              num+= item1.batch_num
          })
         return  this.ruleForm.stock - num + item.batch_num
      }
    }
  },
  data() {
    return {
      moren: require("@/assets/images/bjt.png"),
      isChecked: false,
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      ruleForm:{
        outbound_price:'',
        type:1,
        stock:1,
        batch_list:[],
      },
      roterPre: roterPre,
      rules:[],
      tableFrom: {
        page: 1,
        limit: 20
      },
      fromList: fromList,
      timeVal: [],
      dialogVisible:false,
      cardLists: [],
      stockId:0,
    }
  },
  mounted() {
    this.getList()
    this.getCardList()
    setTimeout(()=>{
      this.expanded()
    },500)
  },
  methods: {
    /**
     * 修改库存
     */
    async batchConfirm(){
      /**
       * 判断批号是否输入完整
       * */
      if(this.ruleForm.batch_list.some((v,i)=>{if(!v.batch_number)return true}))
      {
        this.$message.error('请检查批号是否输入完整')
        return
      }
      if(this.ruleForm.type == 0){ // 减少库存的时候必传出库价格
        if(!this.ruleForm.outbound_price){
          this.$message.error('请输入出库价格')
          return
        }
      }

      let data = await stockSetUpdate(this.stockId,this.ruleForm)
      this.getList()
      this.handleClose()
    },
    handleClose(){
      this.dialogVisible = false
    },
    batchChange(e,index){
      if(e<=0){
       this.$nextTick(()=>{
         this.ruleForm.batch_list.splice(index,1)
       })
      }
    },
    expanded(){
      const els = document.getElementsByClassName('el-table__expand-icon');
      this.$nextTick(()=>{
        els[0].click()
      })
    },
    /**
     * 增加批号
     * */
    addBatchFn(){
      let num = 0
      this.ruleForm.batch_list.map((item,index)=>{
        num+= item.batch_num
      })
      if(num < this.ruleForm.stock){
        this.ruleForm.batch_list.push({batch_number:'',batch_num: 1})
      }

    },
    // 列表
    getList() {
      this.listLoading = true
      RecoveryStockLadderListApi(this.tableFrom).then(res => {
        res.data.list.map((item1,index1)=>{
          item1.recovery_category_id = item1.recovery_category_id?item1.recovery_category_id:index1
          item1.children.map((v,i)=>{
            v.recovery_category_id = v.recovery_category_id?v.recovery_category_id:index1+''+i
          })
        })
        this.tableData.data = res.data.list
        this.listLoading = false
        this.tableData.data.map((item, index) => {
          item.children.map((item1, index1) => {
            item1.children.map((item2, index2) => {
              item2.recovery_category_id = index + '' + index1 + '' + index2
            })
          })
        })
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    pageChange(page) {
      this.tableData.page = page
      this.getList()
    },
    handleSizeChange(val) {
      this.tableData.limit = val
      this.getList()
    },
    // 选择时间
    selectChange(tab) {
      this.tableFrom.date = tab;
      this.tableFrom.page = 1;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.date = e ? this.timeVal.join("-") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },
    // 删除
    // 设置库存
    setRecoveryStock(row) {
      this.dialogVisible = true
      this.stockId = row.recovery_stock_id
      this.ruleForm={
        outbound_price:'',
          type:1,
          stock:1,
          batch_list:[],
      }
      // this.$modalForm(setRecoveryStockFormApi(row.recovery_stock_id)).then(() => this.getList(''))
    },
    getCardList(){
      recoveryStockCardListApi(this.tableFrom)
        .then((res) => {
          this.cardLists = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
  }
}
</script>

<style scoped lang="scss">
</style>
